import React, { useState } from 'react';
import ChatInterface from '../components/Chat/ChatInterface';
import GedcomImport from '../components/GedcomImport/GedcomImport';

const ResearchPage = () => {
  const [activeTree, setActiveTree] = useState(null);
  const [showTree, setShowTree] = useState(false);

  const handleTreeLoaded = (treeData) => {
    setActiveTree(treeData);
  };

  return (
    <div style={{maxWidth: '1200px', margin: '0 auto', padding: '1rem'}}>
      <div style={{marginBottom: '1.5rem', textAlign: 'center'}}>
        <h1 style={{fontStyle: "italic"}}>
          <span style={{color: "#2e7d32"}}>Powered by </span>
          <span style={{color: "#8b4513"}}>GN</span>
          <span style={{color: "#2e7d32"}}>ology</span>
          <span style={{color: "#2e7d32"}}>™</span>
        </h1>
        <p style={{marginBottom: '1rem', color: '#666'}}>
          Chat with Gene about your genealogical research
        </p>
      </div>

      {/* GEDCOM Toggle */}
      <div style={{ textAlign: 'center', marginBottom: '1rem' }}>
        <button
          onClick={() => setShowTree(!showTree)}
          style={{
            background: showTree ? '#2e7d32' : 'transparent',
            color: showTree ? 'white' : '#2e7d32',
            border: '1.5px solid #2e7d32',
            padding: '8px 20px',
            borderRadius: 20,
            fontSize: 13,
            fontWeight: 600,
            cursor: 'pointer',
            transition: 'all 0.2s',
          }}
        >
          🌳 {showTree ? 'Hide' : 'Show'} Family Trees
          {activeTree && !showTree && (
            <span style={{
              marginLeft: 8, background: 'rgba(46,125,50,0.1)',
              padding: '2px 8px', borderRadius: 10, fontSize: 11,
            }}>
              {activeTree.name || activeTree.totalIndividuals + ' people'}
            </span>
          )}
        </button>
      </div>

      {/* GEDCOM Import Panel */}
      {showTree && (
        <div style={{ marginBottom: '1.5rem' }}>
          <GedcomImport onTreeLoaded={handleTreeLoaded} />
        </div>
      )}

      <ChatInterface activeTreeId={activeTree ? (activeTree.treeId || activeTree._id) : null} />
    </div>
  );
};

export default ResearchPage;
